// Notificaciones: preferencias, modo enfoque, Telegram/push del usuario y
// bandeja de avisos.

import { api } from "./http";

export type PrefsNotif = {
  notif_push: boolean;
  notif_telegram: boolean;
  notif_email: boolean;
  telegram_vinculado: boolean;
  notif_silencio: boolean;
  silencio_inicio: string; // "HH:MM"
  silencio_fin: string;
  silencio_finde: boolean;
  // Ruteo por urgencia (Task 10): tipo de aviso -> nivel, y nivel -> canales
  // externos (push/telegram; in-app siempre va, no se lista aquí). Overrides
  // del usuario; lo no presente cae al default de `lib/notifMeta.ts`.
  notif_tipo_urgencia: Record<string, string>;
  notif_nivel_canales: Record<string, string[]>;
  // Modo enfoque: silencia push/Telegram hasta esta fecha (ISO). null = apagado.
  enfoque_hasta: string | null;
};

/** Modo enfoque (Task 12): activa el silencio de push/Telegram por
 *  `minutos` (in-app sigue recibiendo todo). Devuelve las prefs actualizadas
 *  (con el nuevo `enfoque_hasta`). */
export function iniciarEnfoque(minutos: number) {
  return api.post<PrefsNotif>("/api/users/me/enfoque", { minutos });
}

/** Termina el modo enfoque antes de tiempo. Devuelve las prefs actualizadas
 *  (`enfoque_hasta` en null). */
export function terminarEnfoque() {
  return api.del<PrefsNotif>("/api/users/me/enfoque");
}

export type TelegramEstado = {
  configurado: boolean;
  bot_username: string | null;
  vinculado: boolean;
};

export type TelegramVinculo = {
  codigo: string;
  deep_link: string;
  expira_en_min: number;
};

export type PushTestOut = {
  total: number;
  enviados: number;
};

export type PushDeviceOut = {
  id: number;
  etiqueta: string;
  estado: "ok" | "sin_confirmar";
  dias_inactivo: number;
  device_id: string | null;
  creado: string;
  ultima_vez: string | null;
};

export type Notificacion = {
  id: number;
  tipo: string;
  titulo: string;
  cuerpo: string | null;
  caso_id: number | null;
  // Folio del caso para navegar directo. null si la alerta no tiene caso.
  caso_folio: string | null;
  leida_at: string | null;
  created_at: string;
  // Nivel de urgencia resuelto por el backend para agrupar la bandeja.
  urgencia: string;
  // true si la alerta es "para mí" (mención/recordatorio propio, asignación, etc.).
  es_mio: boolean;
};

export type NotificacionesResumen = {
  total_no_leidas: number;
  items: Notificacion[];
};
